import { render } from "./my-load-panel.vue?vue&type=template&id=311f87b2"
import script from "./my-load-panel.vue?vue&type=script&lang=js"
export * from "./my-load-panel.vue?vue&type=script&lang=js"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__